import React, {useContext, useReducer, useState} from 'react'
import {TableCell, TableRow} from '@material-ui/core';
import Tr from 'translations/Translations';
import moment from "moment";
import WorkableIconDeleteButton from 'components/button/WorkableIconDeleteButton';
import WorkableIconDownloadButton from 'components/button/WorkableIconDownloadButton';
import DateFormats from "constants/DateFormats";
import iconWorksReducer from "libs/iconWorksReducer";
import {ContractorDocumentTypeLabel, ContractorDocumentTypeSelectItems} from "constants/ContractorDocumentType";
import WorkableIconEditButton from "components/button/WorkableIconEditButton";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import {useParams} from "react-router";
import EditFilePopup from "./EditFilePopup";
import DemandAdditionalOffersOfferService from "services/DemandAdditionalOffersOfferService";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import Select from "components/Select";
import {OfferMode} from "../../../../common/constants/OfferMode";
import {RoundType} from "constants/RoundType";
import DemandOffersAuctionService from "services/DemandOffersAuctionService";
import {simpleConfirm} from "libs/ConfirmNotification";
import OfferSectionContext from "context/OfferSectionContext";
import WorkableIconButton from "components/button/WorkableIconButton";
import SignatureIcon from "components/icon/SignatureIcon";
import OfferFilesTableSignStatus from "./OfferFilesTableSignStatus";
import SupportModeContext from "context/SupportModeContext";
import getObjectValue from "libs/getObjectValue";
import {TrueFalseWithEmpty} from "constants/TrueFalseItems"
import HelpComponent from "../../../../../../../../../../components/HelpComponent";

function OfferFilesTableRow(
    {
        formikProps,
        index,
        row,
        disabled,
        onePositionMode,
        positionIdToOrderMap,
        mode,
        classes,
        roundType,
        bulkEdit,
        passiveOfferForm,
        signFileAvailable,
        onSignDocument
    }) {
    const params = useParams();
    const [editFile, setEditFile] = useState(null);
    const purchaserOfferContext = useContext(PurchaserOfferContext);
    const supportMode = useContext(SupportModeContext);
    const contextSection = useContext(OfferSectionContext);

    const [iconWorks, dispatchIconWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        download: false,
        edit: false,
        delete: false,
    });

    const onDownload = () => {
        dispatchIconWorks({type: 'download', works: true});
        let promise;
        switch (roundType) {
            case RoundType.BASE:
                promise = DemandOffersOfferService.getDownloadOfferFile(params.id, params.stageId, mode, row.identity, purchaserOfferContext?.supplierId)
                break;
            case RoundType.ADDITIONAL_OFFERS:
                promise = DemandAdditionalOffersOfferService.getDownloadOfferFile(params.id, params.stageId, mode, row.identity, purchaserOfferContext?.supplierId)
                break;
            case RoundType.AUCTION:
                promise = DemandOffersAuctionService.getDownloadOfferFile(params.id, params.stageId, mode, row.identity, purchaserOfferContext?.supplierId)
                break;
            default:
                throw new Error("Unknown roundType: " + roundType)
        }
        promise.finally(() => {
            dispatchIconWorks({type: 'download', works: false});
        })
    }

    const onDelete = () => {
        simpleConfirm("confirm_delete_file", doDelete)
    }
    const doDelete = () => {
        dispatchIconWorks({type: 'delete', works: true});
        let promise;
        switch (roundType) {
            case RoundType.BASE:
                promise = DemandOffersOfferService.deleteOfferFile(params.id, params.stageId, mode, purchaserOfferContext?.supplierId, row.identity)
                break;
            case RoundType.ADDITIONAL_OFFERS:
                promise = DemandAdditionalOffersOfferService.deleteOfferFile(params.id, params.stageId, mode, purchaserOfferContext?.supplierId, row.identity)
                break;
            default:
                throw new Error("Unknown roundType: " + roundType)
        }
        promise.finally(() => dispatchIconWorks({type: 'delete', works: false}));
    }

    const updateFile = (data) => {
        dispatchIconWorks({type: 'edit', works: true});
        let promise;
        switch (roundType) {
            case RoundType.BASE:
                promise = DemandOffersOfferService.editOfferFile(params.id, params.stageId, row.identity, mode, purchaserOfferContext?.supplierId, data)
                break;
            case RoundType.ADDITIONAL_OFFERS:
                promise = DemandAdditionalOffersOfferService.editOfferFile(params.id, params.stageId, row.identity, mode, purchaserOfferContext?.supplierId, data)
                break;
            default:
                throw new Error("Unknown roundType: " + roundType)
        }
        promise.finally(() => dispatchIconWorks({type: 'edit', works: false}));
        setEditFile(null);
    }


    return (<TableRow>
        <TableCell>{row.file.name}</TableCell>
        <TableCell>{moment(row.file.insertDate).format(DateFormats.DATETIME_FORMAT)}</TableCell>
        <TableCell className={classes.typeColumn}>
            {bulkEdit ?
                <Select
                    className={classes.typeColumn}
                    id={`form.${index}.containsRodo`}
                    formikProps={formikProps}
                    items={TrueFalseWithEmpty}
                    disabled={disabled}
                />
                : TrueFalseWithEmpty.find(x => x.value === row.containsRodo).label}
        </TableCell>
        <TableCell className={classes.typeColumn}>
            {bulkEdit ?
                <Select
                    className={classes.typeColumn}
                    id={`form.${index}.documentType`}
                    formikProps={formikProps}
                    items={ContractorDocumentTypeSelectItems(getObjectValue(`form.${index}.documentType`, formikProps.values, null))}
                    disabled={disabled}
                />
                : ContractorDocumentTypeLabel(row.documentType)}
        </TableCell>
        <TableCell><HelpComponent text={`${row.file.fileSize}, SHA256: ${row.file.sha256}`}></HelpComponent></TableCell>
        {!onePositionMode &&
            <TableCell>{row.positionId ? Tr(passiveOfferForm ? 'round_additional_x' : 'part_x', {x: positionIdToOrderMap[`positionId_${row.positionId}`]}) : Tr("whole_demand")}</TableCell>}
        {(!purchaserOfferContext && (!!contextSection.digitalSign || passiveOfferForm)) && <TableCell className={classes.buttonColumn}>
            <OfferFilesTableSignStatus row={row} />
        </TableCell>}
        {
            !purchaserOfferContext && signFileAvailable && <TableCell className={classes.buttonColumn}>
                {!!row.signatureConfiguration &&
                    <WorkableIconButton
                        tooltip={Tr('sign_document')}
                        Icon={SignatureIcon}
                        onClick={() => onSignDocument(row)}
                        disabled={supportMode}
                    />
                }
            </TableCell>
        }

        <TableCell className={classes.buttonColumn}>
            {!row.inaccessible && <WorkableIconDownloadButton
                onClick={onDownload}
                disabled={iconWorks.anyWorks || supportMode}
                working={iconWorks.download}
            />}
        </TableCell>

        {!disabled && (!purchaserOfferContext || mode === OfferMode.EDIT) && <TableCell className={classes.buttonColumn}>
            {!row.inaccessible && <WorkableIconEditButton
                tooltip={Tr('edit_type')}
                disabled={iconWorks.anyWorks || disabled || supportMode}
                working={iconWorks.edit}
                onClick={() => setEditFile(row)}
            />}
            {!!editFile &&
                <EditFilePopup
                    file={editFile}
                    onCancel={() => setEditFile(null)}
                    onUpdate={(data) => updateFile(data)}
                />
            }
        </TableCell>}

        {!disabled && (!purchaserOfferContext || mode === OfferMode.EDIT) && <TableCell className={classes.buttonColumn}>
            {!row.inaccessible && <WorkableIconDeleteButton
                tooltip={Tr('delete')}
                onClick={onDelete}
                disabled={iconWorks.anyWorks || disabled || supportMode}
                working={iconWorks.delete}
            />}
        </TableCell>}
    </TableRow>)
}

OfferFilesTableRow.propTypes = {};

export default OfferFilesTableRow;